

















import { Component, Vue, Emit, Prop } from 'vue-property-decorator'

@Component
export default class ComponentTopHeaderImg extends Vue {
  @Prop({ default: '/img/logos/logo-finx.png' }) img: string
  @Prop({ default: 'Fin-X' }) alt: string
  @Prop({ default: '' }) cl: string
  @Prop({ default: false }) loadingClose: boolean
}
